import { min, max, uniq } from 'lodash'

export function formatNumberToLabel(value: number) {
  const thousands = value / 1000
  const millions = thousands / 1000
  const billions = millions / 1000

  if (Math.trunc(billions) > 0) {
    return `${billions.toFixed(2)}B`
  } else if (Math.trunc(millions) > 0) {
    return `${millions.toFixed(2)}M`
  } else if (Math.trunc(thousands) > 0) {
    return `${thousands.toFixed(2)}k`
  }

  return value.toFixed(2)
}

export const calculateCollateralFromLTV = (ltv: number) => {
  return ltv === 0 ? 0 : Math.floor((100 / ltv) * 100)
}

export const getCollateralRangeFromLTVs = (ltvs: number[]): number[] => {
  const minLtv = min(ltvs) || 0
  const maxLtv = max(ltvs) || 0
  const minCollateral = calculateCollateralFromLTV(maxLtv)
  const maxCollateral = calculateCollateralFromLTV(minLtv)
  // sort is needed in case minLtv is zero
  return uniq([minCollateral, maxCollateral].sort((a, b) => a - b))
}
